var DEBUG = __BUILD_DEBUG__;
